export const isSVGfile = file => /\.svg$/i.test(file);
export const isJPGfile = file => /\.(jpe?g)$/i.test(file);
export const isGIFfile = file => /\.gif$/i.test(file);
//# sourceMappingURL=images-file-type-detection.js.map